import { createFileRoute } from '@tanstack/react-router';

import { ProjectDetail } from '@/features/projects/ProjectDetail';
import { ProjectModeProvider } from '@/features/projects/ProjectModeContext';

export const Route = createFileRoute('/_authenticated/fair-quote/$projectSlug/')({
  component: function Page() {
    const { projectSlug } = Route.useParams();
    return (
      <ProjectModeProvider value='/fair-quote'>
        <ProjectDetail projectSlug={projectSlug} />
      </ProjectModeProvider>
    );
  },
});
